import { createContext, useContext } from "react";

export const ChatContext = createContext({
  analyzeQuestion: async ({ question, chatItems, hasIpAsset }: { question: string; chatItems?: ChatItem[]; hasIpAsset: boolean }) =>
    Promise.resolve({} as ChatItem),
  getAnswer: async function* ({
    question,
    chatItems,
    abortController,
  }: {
    question: string
    chatItems?: ChatItem[]
    abortController: AbortController
  }) {
    yield ''
  },
  showTechnicalItems: false,
})

export type ChatItemType = 'user' | 'assistant' | 'error' | 'system' | 'tool'

export type FunctionCall = { name: string; arguments: any }

export type ChatItem = {
  content: string
  role: ChatItemType
  tool_calls?: { function: FunctionCall }[]
}

export function useChat() {
    return useContext(ChatContext)
}